export default __webpack_public_path__ + "static/media/subdir.d1718197.svg";